import axios from "axios";

const baseUrl = process.env.REACT_APP_DIFLEX_API_URL + "/users";

/**
 * Submits an offboarding request for a user (epic #288). The API disables the account on the
 * end date, schedules the deletion, and mails the case to Diflex.
 *
 * @param {object} payload - { source, tenantPublicId, userPublicId, endDate, deletionDate, ... }
 * @param {string} apiAccessToken - Bearer token for the Insight API
 * @returns {Promise<{ caseReference: string, scheduled: boolean }>} The case reference and
 *          whether the automation managed to schedule the offboarding
 */
export async function submitOffboarding(payload, apiAccessToken) {
  const response = await axios.post(`${baseUrl}/Offboarding/submit`, payload, {
    headers: { Authorization: `Bearer ${apiAccessToken}` },
  });
  return response.data;
}
